import React from 'react';

const SessionCell = ({ row }) =>
  row.session_id === 0 ? (
    <span>{row.session_start_text}</span>
  ) : (
    <div>
      <a
        className="tp-link"
        href={`/sessiondetails?id=${row.session_uuid}`}
        target="_blank"
        rel="noopener noreferrer"
        title={row.session_uuid}
      >
        {row.session_start_text}
      </a>
      {row.student_name ? <div className="tp-card-field-label">{row.student_name}</div> : null}
    </div>
  );

export default SessionCell;
